import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { TruncatedTextWithTooltip } from "app/pages/sales-intelligence/common-components/TruncatedText";

const blurredTextStyle = css`
    overflow: visible;
    filter: blur(4px);

    & > * {
        overflow: visible;
    }
`;

export const StyledContactBaseInfoStack = styled(Stack)`
    position: relative;
    height: 100%;
    min-height: 120px;
    padding: 8px 12px;
    align-self: stretch;
    overflow: hidden;

    border-radius: 3px;
    border: 1px solid ${colorsPalettes.carbon[50]};
`;

export const StyledContactNameText = styled(TruncatedTextWithTooltip)<{ isHidden?: boolean }>`
    ${({ isHidden }) => isHidden && blurredTextStyle}
`;
